module.exports = __webpack_public_path__ + "img/3_1_m.60e262a1.jpg";